@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}


<div style="margin: 0px;">
  @if (myForm) {
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>

      <div [hidden]="is_loading">

        <mat-card style="width: 800px; margin-top: 20px; margin-left: 20px;">

          <mat-card-header>
            <h2>Ad Group</h2>
          </mat-card-header>

          <mat-card-content>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Adgroup Name:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Adgroup Type:</mat-label>
              <mat-select formControlName="type" (focus)="onFocus()">
                <mat-option value="sms">SMS</mat-option>
                <mat-option value="email">Email</mat-option>
                <mat-option value="push">Push Notification</mat-option>
                <mat-option value="image_300x250">Image (300W x 250H)</mat-option>  <!-- Width: 300px, Height: 250px-->
              </mat-select>
              <mat-error style="font-size: 12px">Valid type required</mat-error>
            </mat-form-field>

            <div style="margin-top: 15px; width: 100%">
              <mat-slide-toggle formControlName="status" (change)="onFocus()">
                {{ myForm.get('status')?.value === true ? 'Active' : 'Paused' }}
              </mat-slide-toggle>
            </div>


            <pre
              style="margin-top: 15px; width: 100%; white-space: pre-wrap; word-break: break-word;"
              [innerHTML]="adTag"
            ></pre>



          </mat-card-content>


          <mat-card-actions>
            <div class="flex-container" style="margin-top: 10px;">
              <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit"
                      style="margin: 15px">{{ submit_text }}
              </button>
              <button mat-raised-button color="accent" [disabled]="is_loading" type="button" (click)="backToAdgroups()"
                      style="margin: 15px">Cancel
              </button>
            </div>
          </mat-card-actions>
        </mat-card>


      </div>


    </form>
  }
</div>
